import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { TransactionService } from '../../core/services/transaction.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-notification-expel',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        @if (member?.status != 2) {
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">除名理由</label>
                  <input type="text" class="form-control" [(ngModel)]="select.reasonForExpulsion" name="reasonForExpulsion" required>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">最終利用月</label>
                  <select class="form-control" [(ngModel)]="select.endDate" name="endDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of endDateOptions; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        }
        @if (member?.status == 2) {
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">除名解除</label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label">※申請を行うと、その時点から会員の状態が「在籍中」になります。ご確認の上、申請ボタンを押下してください。</label>
                </div>
              </div>
            </div>
          </div>
        }
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            @if (member?.status != 2) {
              <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
              <button type="button" (click)="save(notificationForm)" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || member?.status != 0"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
            }
            @if (member?.status == 2) {
              <a [routerLink]="['/member']" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
              <button type="button" (click)="returnMember(notificationForm)" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationExpelComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private transactionService = inject(TransactionService);
  private route = inject(ActivatedRoute);

  private batchDay = 11;
  memberId!: number;
  member: any = null;
  endDateOptions: any[] = [];
  select: any = { endDate: null, reasonForExpulsion: '' };
  saving = false;
  completed = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    this.member = await this.memberService.getOne(this.memberId);
    this.endDateOptions = this.buildEndDateOptions(this.batchDay);
  }

  buildEndDateOptions(batchDay: number): any[] {
    const now = new JstDate();
    const endDateModify = batchDay <= now.getDate() ? 1 : 0;
    const billingMonthModify = Number(this.member?.payment?.paymentMethod ?? 0);
    const options = [];
    for (let i = 1; i <= 4; i++) {
      const endDate = new JstDate(now.getFullYear(), now.getMonth() + i + endDateModify, 0);
      options.push({
        id: endDate.getFullYear() + '-' + (endDate.getMonth() + 1),
        name: String(endDate.getFullYear()) + '年' + ('0' + String(endDate.getMonth() + 1)).slice(-2) + '月',
        date: endDate,
      });
    }
    return options;
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed || this.member?.status != 0) return;
    this.saving = true;
    try {
      const now = new JstDate();
      const result = await this.notificationService.upsert({
        studioId: this.member.studio.id,
        memberId: this.member.id,
        requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
        requestType: 7,
        endDate: this.select.endDate?.date,
        note: this.select.reasonForExpulsion,
      });
      if (!result) {
        this.showFeedback('danger', '諸届申請を更新できませんでした');
        return;
      }
      this.completed = true;
      this.resetInputs(form);
      this.showFeedback('success', '諸届申請を更新しました');
    } finally {
      this.saving = false;
    }
  }

  async returnMember(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed) return;
    this.saving = true;
    try {
      const now = new JstDate();
      const result = await this.notificationService.upsert({
        memberId: this.member.id,
        studioId: this.member.studio.id,
        requestType: 8,
        status: 2,
        acceptedAt: now,
        requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
      });
      if (!result) {
        this.showFeedback('danger', '諸届申請を更新できませんでした');
        return;
      }
      await this.memberService.upsert({
        id: this.member.id,
        status: 0,
        expelledAt: null,
      });
      await this.memberService.createHistory({
        memberId: this.member.id,
        studioId: this.member.studioId ?? this.member.studio?.id,
        studioPlanId: this.member.studioPlan?.id,
        startDate: now,
      });
      this.completed = true;
      this.resetInputs(form);
      this.showFeedback('success', '諸届申請を更新しました');
    } finally {
      this.saving = false;
    }
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = { endDate: null, reasonForExpulsion: '' };
    form?.resetForm({ endDate: null, reasonForExpulsion: '' });
  }
  private refreshClockDates(): void {
    this.endDateOptions = this.buildEndDateOptions(this.batchDay);
    this.select.endDate = null;
  }

}
